<!--
  (c) Copyright 2024 Calabrio, Inc.
  All Rights Reserved. www.calabrio.com LICENSED MATERIALS
  Property of Calabrio, Inc., Minnesota, USA

  No part of this publication may be reproduced, stored or transmitted,
  in any form or by any means (electronic, mechanical, photocopying,
  recording or otherwise) without prior written permission from Calabrio, Inc.
-->

<template>
  <div class="wy-configuration-kpis-contact-reasons">
    
    <el-dropdown  placement="bottom-start" trigger="click" :ref="kpi.metric + 'ContactReasonFilter'" :show-timeout="0" :hide-timeout="0" @visible-change="handleChangeVisible($event, selectedContactReasons, kpi)">
      <div class="kpi-topic">
        <!-- <span v-if="controller.showAddTopicBtn(kpi)" class="span-plus">+</span> -->
        <el-button v-if="controller.showAddTopicBtn(kpi)" icon="el-icon-plus" class="new-topic-button" size="small"> Select topics (max 10)</el-button>
        <el-button v-else-if="kpi.items.length<=10" class="add-new-topic"></el-button>
      </div>
      <div :class="{'overlay': true, 'visible': isVisible}">
        <el-dropdown-menu
          class="wy-analytics-kpi-config-dropdown-menu contact-reasons"
          slot="dropdown"
        >
          <div class="contact-reason-label">Conversation Topics</div>
          <span class="remove-item el-icon-close" @click="handleCancel($refs[kpi.metric + 'ContactReasonFilter'])"></span>
            <!-- <div class="btn-select-all">
              <img src="../../assets/icons/icon_transcript_close.svg" @click="handleCancel($refs.contactReasonFilter)">
            </div> -->
            <div class="horizontal-line">
              <div class="search-button material-icons">search</div>
              <input
                ref="contactReasonSearch"
                name="filter"
                type="text"
                class="reg-inp"
                :class="{'input-hight-light': contactReasonKeywords!=''}"
                v-model="contactReasonKeywords"
                placeholder="Search by topic"
              /><i v-if="contactReasonKeywords!=''" class="fas fa-times-circle" @click="clearSearch"></i>
              <br />
              <div class="check-box-section" v-loading="topicFilterLocalLoading">
                <div v-if="filteredContactReasons.length>0">
                  <el-checkbox-group v-model="selectedContactReasons">
                    <el-checkbox
                      v-for="(item, index) in filteredContactReasons"
                      :key="index"
                      class="checkbox"
                      :name="item.contactReason"
                      :label="item.contactReason"
                      :disabled="selectedContactReasons.length>=11&&index>9"
                    >
                    <span class="display-topic-name">{{item.contactReason}}</span> 
                    <span class="topic-number"> ({{item.volume * $store.getters.xnumber}})</span>
                    </el-checkbox>
                  </el-checkbox-group>
                </div>
                <div v-else class="no-contact-reason">no matching data</div>
              </div>
            </div>
            <div class="card-bottom-part">
              <!-- <el-button v-if="transcriptFilters['topicDisplayNames'] && transcriptFilters['topicDisplayNames'].length>0" plain class="clear-btn" @click="resetContactReasons()"><span class="clear-filter-text">Reset all</span></el-button> -->
              <el-button plain class="apply-btn" @click="handleApplyAddTopics($refs[kpi.metric + 'ContactReasonFilter'])"><span class="clear-filter-text">Apply</span></el-button> 
              <el-button plain class="clear-btn" @click="handleCancel($refs[kpi.metric + 'ContactReasonFilter'])"><span class="clear-filter-text">Cancel</span></el-button>
          </div>
        </el-dropdown-menu>
      </div>
    </el-dropdown>    
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';

  export default {
    name: 'wy-configuration-kpis-contact-reasons',
    props: ['controller', 'topicFilterLoading', 'contactReasonsList', 'kpi', 'kpiIndex'],

    watch: {
      selectedContactReasons: {
        handler: function(newValue) {
          setTimeout(()=>{
            this.selectedContactReasonsModel = newValue;
            if(newValue.length >= 11) {
              if(!this.preMsgObj) {
                this.preMsgObj = this.$message({
                  message: `Only 10 conversation topics can be selected for alert configuration.`,
                  showClose: true,
                  type: 'warning',
                  duration: 5000,
                  customClass: "kpi-topic-limitation-warning",
                  onClose: ()=>{
                    this.preMsgObj = null;
                  }
                });
              }
            }
          },20)
        },
        deep: true
      },

      topicFilterLoading() {
        this.topicFilterLocalLoading = this.topicFilterLoading;
      }
    },
    
    data() {
      return {
        module: this,
        isVisible: false,
        isCancel: false,
        contactReasonKeywords: '',
        selectedContactReasons: [],
        selectedContactReasonsClone: [],
        selectedContactReasonsModel: [],
        topicFilterLocalLoading: false,
        preMsgObj: null
      };
    },

    computed: {
      ...mapGetters(['dataModel', 'isRoleAllow', 'companyConfig', 'companyProfileSettings']),

      filteredContactReasons() {
        return this.getFilteredContactReasons();
      }
    },

    methods: {

      clearSearch() {
        this.contactReasonKeywords = '';
      },

      handleCancel(el) {
        this.isCancel = true;
        el.hide();
      },

      handleChangeVisible(show, selectedContactReasons, kpi) {
        if(!show) {
          this.isVisible = false;
          if(!this.isCancel) {
            selectedContactReasons.forEach((selectedTopic, index) => {
              if(index > 0) {
                if(kpi.items.length > 1) {
                  // console.log(">1")
                  if(kpi.items.filter(topic =>{ return topic.topicDisplayName == selectedTopic}).length == 0) {
                    let topic = {
                      topicDisplayName: selectedTopic,
                      type: 'topic',
                      isChanged: true,
                      rules: []
                    }
                    kpi.items.push(topic);
                  }
                }
                else {
                  let topic = {
                    topicDisplayName: selectedTopic,
                    type: 'topic',
                    isChanged: true,
                    rules: []
                  }
                  kpi.items.push(topic);
                }
              }
            })
            kpi.items = kpi.items.filter(topic =>{return selectedContactReasons.includes(topic.topicDisplayName)})
            this.controller.localKPIDataWithExtraProps[this.kpiIndex].selectedContactReasons = selectedContactReasons;
          }
          else {
            this.selectedContactReasons = JSON.parse(JSON.stringify(this.selectedContactReasonsClone));
          }
          this.controller.localKPIDataWithExtraProps[this.kpiIndex].items = kpi.items;
          this.controller.localKPIDataWithExtraProps[this.kpiIndex].items.forEach(topic => {
            if(!topic.tooltipExpendTopic) {
              topic.tooltipExpendTopic = 'Expand topic';
            }
          })
          // console.log(this.selectedContactReasons,  kpi.items, this.controller.localKPIDataWithExtraProps[this.kpiIndex])
          this.controller.localKPIDataWithExtraProps[this.kpiIndex].expendedTopics.forEach((topicName, index) =>{
            if(!this.selectedContactReasons.includes(topicName)) {
              this.controller.localKPIDataWithExtraProps[this.kpiIndex].expendedTopics.splice(index, 1);
            }
          })
          this.contactReasonKeywords = '';
        }
        else {
          this.isVisible = true;
          // console.log(this.controller.localKPIDataWithExtraProps, this.kpiIndex)
          this.topicFilterLocalLoading = this.topicFilterLoading;
          if(this.controller.localKPIDataWithExtraProps[this.kpiIndex].selectedContactReasons) {
            this.selectedContactReasons = this.controller.localKPIDataWithExtraProps[this.kpiIndex].selectedContactReasons;
          }
          this.selectedContactReasonsClone = JSON.parse(JSON.stringify(this.selectedContactReasons));
        }
        this.isCancel = false;
      },

      handleApplyAddTopics(el) {
        el.hide();
      },

      getFilteredContactReasons() {
        let filteredListSelected = this.contactReasonsList ? this.contactReasonsList.filter(item => {
          return this.selectedContactReasonsModel.includes(item.contactReason)
        }) : [];
        let filteredList = this.contactReasonsList ? this.contactReasonsList.filter(item => {
          return !this.selectedContactReasonsModel.includes(item.contactReason) && item.contactReason.toLowerCase().includes(this.contactReasonKeywords.trim().toLowerCase())
        }) : [];
        return filteredListSelected.concat(filteredList);
        // return this.contactReasonsList ? this.contactReasonsList.sort((a) => (this.selectedContactReasonsModel.includes(a.contactReason)) ? -1 : 1) : []
      },
    }
  };
</script>

<style lang="scss">
  .wy-configuration-kpis-contact-reasons {
    margin: 0px 0px 0px 10px;
    width: 10px;
    .kpi-topic {
      position: relative;
      .span-plus {
        font-size: 26px;
        position: absolute;
        top: -10px;
        left: 8px;
        color: #1A55AD;
      }
      .new-topic-button {
        border-radius: 4px;
        padding: 9px 16px 8px 12px;
        color: #1A55AD;
        border: 1px #1A55AD solid;

        .el-icon-plus {
          font-size: 14px;
          font-weight: 600;
        }
        span {
          padding-left: 0px;
          margin-left: 0px;
          font-size: 14px;
        }
      }
      .new-topic-button:hover {
        background-color: #F4F6F8 !important;
        border: 1px #1A55AD solid;
      }
      .new-topic-button:focus {
        background-color: unset;
      }
    }
    .add-new-topic {
      display: block;
      padding: 0px;
      border: 0px;
      background-image: url('../../../assets/icons/circle-plus_minor.svg') !important;
      cursor: pointer;
      background-size: 20px;
      background-repeat: no-repeat;
      background-position-y: 0px;
      background-position-x: 0px;
      background-color: transparent;
      border-radius: 16px;
      position: relative;
      height: 20px;
      width: 20px;
    }


    .overlay {
      position: fixed;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      background: rgba(255, 255, 255, 0.1);
      transition: opacity 500ms;
      visibility: hidden;
      backdrop-filter: blur(2px);
      opacity: 0;
      z-index: 9999;
    }

    .overlay.visible {
      visibility: visible;
      opacity: 1;
    }
  }

  .wy-analytics-kpi-config-dropdown-menu.contact-reasons {
    width: 620px !important;
    border-radius: 5px;
    top: calc(50% - 300px) !important;
    left: calc(50% - 200px) !important;

    .el-checkbox__inner {
      font-family: "Helvetica Neue", Helvetica, Arial, sans-serif !important;
      border: 2px solid #CAD2DA !important;
      width: 18px;
      height: 18px;
    }
    .el-checkbox__input.is-checked .el-checkbox__inner {
      background-color: #0C2837;
      border-color: #0C2837 !important;
    }
    .el-checkbox__input.is-checked .el-checkbox__inner::after {
      left: 5px;
      top: 2px;
    }
    
    .horizontal-line {
      margin-right: 0px;
      margin-left: 0px;
      padding-right: 5px;
      margin-bottom: 0px;
      padding-top: 25px;
      padding-bottom: 0px;
      overflow: hidden;
      border-top: 1px solid #CAD2DA;
      border-bottom: 1px solid #CAD2DA;

      .check-box-section {
        height: 183px;
        overflow-y: auto;
        &::-webkit-scrollbar {
          background-color: white !important;
          width: 6px !important;
        }
        &::-webkit-scrollbar-thumb{
          background: #CAD2DA !important;
          border-radius: 50px !important; 
        } 
        .no-contact-reason {
          padding-left: 30px;
          text-align: center;
        }
      }
      .check-box-section .checkbox-first-row {
        margin-left: 16px;
        padding-bottom: 2px !important;
      }
      .reg-inp {
        background: #ffffff;
        border: 1px solid #CAD2DA;
        box-sizing: border-box;
        border-radius: 4px;
        height: 36px;
        margin-left: 0px !important;
        margin-bottom: 15px;
        padding: 5px 28px 5px 39px;
        width: 570px;
      }
      .material-icons {
        position: relative;
        left: 35px;
        top: 8px;
      }
    }
    .card-bottom-part {
      // max-width: 582px;
    }
    .contact-reason-label {
      display: inline-block;
      padding-top: 5px;
      padding-bottom: 15px;
      padding-left: 23px;
      color: var(--site-font-secondary-color);
      font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
      font-size: 20px;
      font-weight: 400;
    }
    span.remove-item.el-icon-close {
      float: right;
      margin-top: 10px;
      margin-right: 20px;
    }
    
    .btn-select-all {
      float: right;
      padding-right: 20px;
      margin-top: 12px;
      cursor: pointer;
      font-size: 14px;
    }
    .input-hight-light {
      background-color: #E8F1FF !important;
    }

    .fa-times-circle {
      position: relative;
      left: -25px;
      bottom: -1px;
      color: #214586;
      font-size: 16px;
      cursor: pointer;
    }
    .el-checkbox__inner {
      border: 2px solid #CAD2DA !important;
    }
    .horizontal-line .el-checkbox-group {
      height: fit-content;
      // overflow-y: auto;
      width: 100%;

      &::-webkit-scrollbar {
        background-color: transparent !important;
        width: 8px !important;
      }
      &::-webkit-scrollbar-thumb{
        background: #CAD2DA !important;
        border-radius: 5px;
      }

      .el-checkbox {
        color: var(--site-font-primary-color);
        margin-top: 15px;
        margin-bottom: 20px;
        margin-left: 25px;
        margin-right: 15px !important;
        display: flex;
        flex-direction: row;
        align-items: center;
        .el-checkbox__label {
          // max-width: 230px;
          padding: 5px 0px 5px 10px;
          line-height: 1;
          width: 95%;
          .display-topic-name {
            display: inline-block;
            outline: none;
            max-width: 473px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            color: var(--site-font-tertiary-color) !important;
            height: 16px;
          }
          .topic-number {
            float: right;
            color: var(--site-font-tertiary-color) !important;
          }
        }
        span.el-checkbox__inner:hover {
          // background-color: transparent;
          box-shadow: unset;
        }
      }
      .el-checkbox__inner {
        top: 0px;
        width: 18px;
        height: 18px;
      }
    }
    .clear-btn {
      position: relative;
      // bottom: -1px;
      // right: 8px;
      font-size: 14.22px;
      color: #202223;
      border: 1px solid #DCDFE6;
      border-radius: 5px;
      padding: 8px 10px 8px 10px;
      margin-left: 10px;
      margin-right: 10px;
      float: right;
      .char {
        margin-left: auto;
      }
    }

    .apply-btn {
      position: relative;
      font-size: 14px;
      color: var(--site-font-chart-color);
      width: 68px;
      height: 33px;
      border-radius: 4px;
      padding: 0px;
      padding-left: 5px;
      color: #FFF;
      background: #0C2837;
      // box-shadow: 0px 1px 0px rgb(0 0 0 / 8%), inset 0px -1px 0px rgb(0 0 0 / 20%);
      border-radius: 4px;
      margin-right: 20px;
      float: right;
    }
    
    .card-bottom-part {
      padding-top: 16px;
    }
  }

  .kpi-topic-limitation-warning {
    background-color: #FFF4F4;
    border-color: #DF96A3;
    width: 519px;

    .el-message__icon.el-icon-warning {
      background-image: url("../../../assets/icons/icon_error_square.svg");
      height: 20px;
      width: 20px;
      background-repeat: no-repeat;
      background-size: 20px;
    }
    .el-message__content {
      color: var(--site-font-secondary-color);
    }
    .el-icon-warning:before {
      content: unset;
    }
    .el-message__closeBtn {
      color: #5C5F62 !important;
    }
  }
</style>